(function () {
  'use strict';

  var instances = {};

  var ICONS = {
    phone: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6.6 10.8c1.2 2.4 3.2 4.4 5.6 5.6l1.9-1.9c.3-.3.7-.4 1-.2 1 .3 2.2.5 3.3.5.6 0 1 .4 1 1V19c0 .6-.4 1-1 1C9.4 20 4 14.6 4 8c0-.6.4-1 1-1h2.6c.6 0 1 .4 1 1 0 1.2.2 2.3.5 3.3.1.4 0 .8-.2 1l-1.9 1.9Z" fill="currentColor"/></svg>',
    email: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm1 2.3V17h14V7.3l-6.4 4.8a1 1 0 0 1-1.2 0L5 7.3Zm1.5-.3 5.5 4.1L17.5 7H6.5Z" fill="currentColor"/></svg>',
    website: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm6.9 8h-3.02a15.6 15.6 0 0 0-1.2-5.3A8.02 8.02 0 0 1 18.9 10ZM12 4.1c.8 1.1 1.5 3 1.8 5.9h-3.6c.3-2.9 1-4.8 1.8-5.9ZM9.3 4.7A15.6 15.6 0 0 0 8.12 10H5.1a8.02 8.02 0 0 1 4.2-5.3ZM5.1 12h3.02c.1 2 .5 3.9 1.2 5.3A8.02 8.02 0 0 1 5.1 12Zm5.02 0h3.76c-.3 2.9-1 4.8-1.88 5.9-.88-1.1-1.58-3-1.88-5.9Zm4.98 5.3c.7-1.4 1.1-3.3 1.2-5.3h3.02a8.02 8.02 0 0 1-4.22 5.3Z" fill="currentColor"/></svg>',
    directions: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M21.7 11.3 12.7 2.3a1 1 0 0 0-1.4 0l-9 9a1 1 0 0 0 0 1.4l9 9a1 1 0 0 0 1.4 0l9-9a1 1 0 0 0 0-1.4ZM13 15v-3H9v2.5L5.5 11 9 7.5V10h4a1 1 0 0 1 1 1v4h-1Z" fill="currentColor"/></svg>',
    arrow: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h13m0 0-5-5m5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function milesBetween(lat1, lon1, lat2, lon2) {
    var R = 3958.8; // Earth radius in miles
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLon = ((lon2 - lon1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function formatDistance(miles) {
    if (miles < 10) return miles.toFixed(1) + ' mi';
    return Math.round(miles) + ' mi';
  }

  function slugify(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  function typeModifierClass(type) {
    var slug = slugify(type);
    if (slug.indexOf('european-heritage') !== -1 || slug === 'eh-showroom' || slug.indexOf('eh-showroom') !== -1) {
      return 'showroom-card__type--flagship';
    }
    return 'showroom-card__type--partner';
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function addressLines(loc) {
    var line1 = [loc.address_line_1, loc.address_line_2].filter(Boolean).join(', ');
    var line2 = [loc.city, loc.post_code].filter(Boolean).join(' ');
    return { line1: line1, line2: line2 };
  }

  function createInstance(sectionId) {
    var root = document.getElementById('ShowroomFinder-' + sectionId);
    if (!root) return null;

    var dataScript = document.querySelector(
      'script[data-showroom-finder-data="' + sectionId + '"]'
    );
    var config = (window.ShowroomFinderConfig && window.ShowroomFinderConfig[sectionId]) || {};
    var rawLocations = [];
    try {
      rawLocations = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Showroom Finder: could not parse location data', e);
    }

    var locations = rawLocations
      .filter(function (loc) {
        return loc.latitude && loc.longitude;
      })
      .map(function (loc) {
        return Object.assign({}, loc, {
          latitude: parseFloat(loc.latitude),
          longitude: parseFloat(loc.longitude)
        });
      });

    var listEl = root.querySelector('[data-showroom-list]');
    var emptyEl = root.querySelector('[data-showroom-empty]');
    var statusEl = root.querySelector('[data-showroom-status]');
    var form = root.querySelector('[data-showroom-search]');
    var input = root.querySelector('[data-showroom-postcode-input]');
    var searchButton = root.querySelector('[data-showroom-search-button]');
    var resetButton = root.querySelector('[data-showroom-reset]');
    var geoButton = root.querySelector('[data-showroom-geo-button]');
    var mapEl = document.getElementById(config.mapId);

    var map = new google.maps.Map(mapEl, {
      zoom: config.defaultZoom || 10,
      center: { lat: 54.5, lng: -3 } // fallback centre: UK
    });
    var geocoder = new google.maps.Geocoder();
    var infoWindow = new google.maps.InfoWindow();

    // Fixed viewport covering the whole of the UK (used as the default view,
    // rather than tightly fitting to whichever markers currently exist).
    var UK_BOUNDS = new google.maps.LatLngBounds(
      { lat: 49.85, lng: -10.85 }, // SW: covers Cornwall / Channel Islands
      { lat: 60.9, lng: 1.85 } // NE: covers far north Scotland / East Anglia
    );

    var markers = {};
    var cardEls = {};
    var activeId = null;
    var userLocationMarker = null;

    function buildInfoWindowContent(loc) {
      var parts = [];

      if (loc.logo) {
        parts.push(
          '<div class="showroom-map-infowindow__header">' +
            '<img class="showroom-map-infowindow__logo" src="' + escapeHtml(loc.logo) + '" alt="' + escapeHtml(loc.name) + ' logo">' +
          '</div>'
        );
      }

      var details = ['<strong>' + escapeHtml(loc.name) + '</strong>'];
      var addr = addressLines(loc);
      if (addr.line1) details.push('<div>' + escapeHtml(addr.line1) + '</div>');
      if (addr.line2) details.push('<div>' + escapeHtml(addr.line2) + '</div>');
      if (loc.phone) details.push('<div>' + escapeHtml(loc.phone) + '</div>');

      var imageHtml = loc.image
        ? '<img class="showroom-map-infowindow__image" src="' + escapeHtml(loc.image) + '" alt="' + escapeHtml(loc.name) + '">'
        : '';

      parts.push(
        '<div class="showroom-map-infowindow__row">' +
          '<div class="showroom-map-infowindow__details">' + details.join('') + '</div>' +
          imageHtml +
        '</div>'
      );

      var actionButtons = buildActionButtons(loc);
      if (actionButtons) {
        parts.push('<div class="showroom-map-infowindow__actions">' + actionButtons + '</div>');
      }

      return '<div class="showroom-map-infowindow">' + parts.join('') + '</div>';
    }

    function setActive(id) {
      if (activeId && cardEls[activeId]) {
        cardEls[activeId].classList.remove('is-active');
      }
      if (activeId && markers[activeId]) {
        markers[activeId].setIcon(null);
        markers[activeId].setZIndex(null);
        markers[activeId].setAnimation(null);
      }

      activeId = id;

      if (id && cardEls[id]) {
        cardEls[id].classList.add('is-active');
      }
      if (id && markers[id]) {
        markers[id].setIcon({
          path: google.maps.SymbolPath.CIRCLE,
          scale: 11,
          fillColor: '#111111',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 3
        });
        markers[id].setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
      }
    }

    function focusLocation(id, opts) {
      opts = opts || {};
      var marker = markers[id];
      var loc = locations.find(function (l) {
        return l.id === id;
      });
      if (!marker || !loc) return;
      setActive(id);
      if (opts.pan !== false) {
        map.panTo(marker.getPosition());
        if (opts.zoom) map.setZoom(Math.max(map.getZoom(), opts.zoom));
      }
      infoWindow.setContent(buildInfoWindowContent(loc));
      infoWindow.open(map, marker);
      if (opts.scrollIntoView && cardEls[id]) {
        cardEls[id].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function createMarkers() {
      locations.forEach(function (loc) {
        var marker = new google.maps.Marker({
          position: { lat: loc.latitude, lng: loc.longitude },
          map: map,
          title: loc.name
        });
        // Store the location id ON the marker itself (rather than relying only
        // on the closure) so the click handler can never resolve to the wrong
        // location, even if markers get re-created.
        marker.set('locationId', loc.id);
        marker.addListener('click', function () {
          focusLocation(marker.get('locationId'), { scrollIntoView: true });
        });
        markers[loc.id] = marker;
      });
    }

    function buildActionButtons(loc) {
      var actions = [];
      if (loc.phone) {
        actions.push(
          '<a class="showroom-card__action" href="tel:' + escapeHtml(loc.phone) + '" data-card-action>' +
            ICONS.phone + '<span>Call</span></a>'
        );
      }
      if (loc.email) {
        actions.push(
          '<a class="showroom-card__action" href="mailto:' + escapeHtml(loc.email) + '" data-card-action>' +
            ICONS.email + '<span>Email</span></a>'
        );
      }
      if (loc.website) {
        actions.push(
          '<a class="showroom-card__action" href="' + escapeHtml(loc.website) + '" target="_blank" rel="noopener" data-card-action>' +
            ICONS.website + '<span>Website</span></a>'
        );
      }
      if (typeof loc.latitude === 'number' && typeof loc.longitude === 'number') {
        var directionsUrl =
          'https://www.google.com/maps/dir/?api=1&destination=' + loc.latitude + ',' + loc.longitude;
        actions.push(
          '<a class="showroom-card__action" href="' + directionsUrl + '" target="_blank" rel="noopener" data-card-action>' +
            ICONS.directions + '<span>Get directions</span></a>'
        );
      }
      if (loc.page_url) {
        actions.push(
          '<a class="showroom-card__action showroom-card__action--primary" href="' + escapeHtml(loc.page_url) + '" data-card-action>' +
            '<span>View more</span>' + ICONS.arrow + '</a>'
        );
      }
      return actions.join('');
    }

    function renderList(items) {
      listEl.querySelectorAll('.showroom-card').forEach(function (el) {
        el.remove();
      });
      cardEls = {};

      if (!items.length) {
        emptyEl.hidden = false;
        return;
      }
      emptyEl.hidden = true;

      items.forEach(function (loc) {
        var card = document.createElement('div');
        card.className = 'showroom-card' + (loc.logo ? ' showroom-card--has-logo' : '');
        card.setAttribute('data-location-id', loc.id);
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');

        var distanceHtml = typeof loc._distance === 'number'
          ? '<span class="showroom-card__distance">' + formatDistance(loc._distance) + '</span>'
          : '';

        var typeHtml = loc.type
          ? '<span class="showroom-card__type ' + typeModifierClass(loc.type) + '">' + escapeHtml(loc.type) + '</span>'
          : '';

        var logoHtml = loc.logo
          ? '<img class="showroom-card__logo" src="' + escapeHtml(loc.logo) + '" alt="' + escapeHtml(loc.name) + ' logo">'
          : '';

        var addr = addressLines(loc);
        var addressHtml = '';
        if (addr.line1 || addr.line2) {
          addressHtml =
            '<div class="showroom-card__address">' +
              (addr.line1 ? '<div>' + escapeHtml(addr.line1) + '</div>' : '') +
              (addr.line2 ? '<div>' + escapeHtml(addr.line2) + '</div>' : '') +
            '</div>';
        }

        var actionButtons = buildActionButtons(loc);
        var footerHtml = (actionButtons || distanceHtml)
          ? '<div class="showroom-card__footer">' +
              '<div class="showroom-card__actions">' + actionButtons + '</div>' +
              distanceHtml +
            '</div>'
          : '';

        card.innerHTML =
          logoHtml +
          '<div class="showroom-card__top">' +
            '<p class="showroom-card__name">' + escapeHtml(loc.name) + '</p>' +
          '</div>' +
          typeHtml +
          addressHtml +
          footerHtml;

        card.addEventListener('click', function () {
          focusLocation(loc.id, { zoom: 14 });
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            focusLocation(loc.id, { zoom: 14 });
          }
        });
        // Action links (call/email/website/view more) navigate on their own;
        // stop the click from also re-triggering the card's own focus/zoom.
        card.querySelectorAll('[data-card-action]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.stopPropagation();
          });
        });

        listEl.appendChild(card);
        cardEls[loc.id] = card;
      });
    }

    function setStatus(message, isError) {
      statusEl.textContent = message || '';
      if (isError) {
        statusEl.setAttribute('data-error', 'true');
      } else {
        statusEl.removeAttribute('data-error');
      }
    }

    function setLoading(isLoading) {
      searchButton.disabled = isLoading;
      searchButton.querySelector('[data-default-label]').hidden = isLoading;
      searchButton.querySelector('[data-loading-label]').hidden = !isLoading;
    }

    function showAll() {
      var sorted = locations.slice().sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      renderList(sorted);
      map.fitBounds(UK_BOUNDS, 0);
      setActive(null);
      setStatus('');
      resetButton.hidden = true;
      if (userLocationMarker) {
        userLocationMarker.setMap(null);
        userLocationMarker = null;
      }
    }

    function placeUserMarker(lat, lng) {
      if (userLocationMarker) {
        userLocationMarker.setMap(null);
      }
      userLocationMarker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: map,
        title: 'Your location',
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 7,
          fillColor: '#1a73e8',
          fillOpacity: 1,
          strokeColor: '#fff',
          strokeWeight: 2
        }
      });
    }

    function applyUserLocation(lat, lng, opts) {
      opts = opts || {};
      var withDistance = locations.map(function (l) {
        return Object.assign({}, l, {
          _distance: milesBetween(lat, lng, l.latitude, l.longitude)
        });
      });
      withDistance.sort(function (a, b) {
        return a._distance - b._distance;
      });

      renderList(withDistance);
      setStatus(
        withDistance.length + ' location' + (withDistance.length === 1 ? '' : 's') + ' found, nearest first.'
      );
      resetButton.hidden = false;
      placeUserMarker(lat, lng);

      if (opts.selectNearest && withDistance.length) {
        // Pan/zoom to the nearest location exactly like clicking its card
        // would (zoom 14), rather than a wider fit-to-bounds overview.
        focusLocation(withDistance[0].id, { zoom: 14, scrollIntoView: true });
      } else {
        var nearestIds = withDistance.slice(0, 5).map(function (l) {
          return l.id;
        });
        var bounds = new google.maps.LatLngBounds();
        bounds.extend({ lat: lat, lng: lng });
        nearestIds.forEach(function (id) {
          if (markers[id]) bounds.extend(markers[id].getPosition());
        });
        map.fitBounds(bounds, 60);
        setActive(null);
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var postcode = input.value.trim();
      if (!postcode) return;

      setLoading(true);
      setStatus('Searching…');

      geocoder.geocode({ address: postcode + ', UK' }, function (results, status) {
        setLoading(false);
        if (status !== 'OK' || !results || !results[0]) {
          setStatus("Couldn't find that postcode. Please check it and try again.", true);
          return;
        }

        var loc = results[0].geometry.location;
        applyUserLocation(loc.lat(), loc.lng(), { selectNearest: true });
      });
    });

    if (geoButton) {
      if (!navigator.geolocation) {
        geoButton.disabled = true;
        geoButton.title = 'Location services are not available in this browser';
      } else {
        geoButton.addEventListener('click', function () {
          geoButton.disabled = true;
          setStatus('Finding your location…');
          navigator.geolocation.getCurrentPosition(
            function (position) {
              geoButton.disabled = false;
              setStatus('');
              applyUserLocation(position.coords.latitude, position.coords.longitude, { selectNearest: true });
            },
            function () {
              geoButton.disabled = false;
              setStatus("Couldn't access your location. Please allow location access or enter a postcode instead.", true);
            },
            { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
          );
        });
      }
    }

    resetButton.addEventListener('click', function () {
      showAll();
    });

    createMarkers();
    showAll();

    return {
      map: map,
      focusLocation: focusLocation
    };
  }

  window.ShowroomFinder = {
    init: function (sectionId) {
      // Guard against being initialized twice for the same section (e.g. if
      // the Shopify theme editor re-renders the section) — re-running this
      // would create a second, orphaned set of markers.
      if (instances[sectionId]) return;
      instances[sectionId] = createInstance(sectionId);
    }
  };
})();
